import { Switch } from "@xola/ui-kit";
import { isNil } from "lodash";
import React, { useCallback, useEffect } from "react";
import { GuestStatus } from "types";
import shallow from "zustand/shallow";
import { getArrivalOffsetMinutes } from "../../models/Purchase";
import { useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { useSeller } from "@/hooks/useAccount";

export const AutoCheckIn = React.memo(() => {
    const seller = useSeller();

    const [arrivalDate, arrivalTime] = useCreatePurchaseStore((state) => {
        const item = state.purchase.items[0];
        return [item.arrivalDate, item.arrivalTime];
    }, shallow);

    const autoCheckIn = useCreatePurchaseStore((state) => state.autoCheckIn);

    const autoCheckInOffset = seller.meta["xola/seller/quickCheckIn/autoCheckInOffset"];
    const arrivalOffset = getArrivalOffsetMinutes(arrivalDate, arrivalTime);
    const autoCheckInEnabled = !isNil(autoCheckInOffset) && autoCheckInOffset >= arrivalOffset;

    const handleChangeAutoCheckIn = useCallback((value: boolean) => {
        useCreatePurchaseStore.setState({ autoCheckIn: value });

        useCreatePurchaseStore.getState().actions.setPurchase((purchase) => {
            for (const item of purchase.items) {
                item.guestStatus = value ? GuestStatus.ARRIVED : GuestStatus.PENDING;
            }
        });
    }, []);

    useEffect(() => {
        useCreatePurchaseStore.setState({ autoCheckIn: autoCheckInEnabled });
        handleChangeAutoCheckIn(autoCheckInEnabled);
    }, [autoCheckInEnabled, handleChangeAutoCheckIn]);

    if (!autoCheckInEnabled) {
        return null;
    }

    return (
        <div>
            <Switch.Group>
                <Switch data-testid="auto-checkin-toggle" isChecked={autoCheckIn} onChange={handleChangeAutoCheckIn} />
                <Switch.Label direction="right" className="text-gray-darker">
                    Check in?
                </Switch.Label>
            </Switch.Group>
        </div>
    );
});
